import React from "react";
import { useState } from "react";
import { UploadIcon } from "../../assets/img/UploadIcon";
import { useSelector } from "react-redux";
import { CreateDropdown } from "./CreateDropdown/CreateDropdown";
import {
  CreateNftButton,
  CreateNftContent,
  CreateNftInfo,
  CreateNftLeft,
  CreateNftRight,
  CreateNftSection,
  CreateNftWrapper,
  CreateNftWrapperMain,
} from "./CreateNft.styled";
import Switch from "react-switch";

const categories = ["Art", "Memes", "Music", "Photography", "Virtual worlds"];
const collections = ["Pixel Punk", "Robotos NFT", "Music"];

export const CreateNft = () => {
  const [activeCategories, setActiveCategories] = useState(categories[0]);
  const [activeCollections, setActiveCollections] = useState(null);
  const [putOnMarketplace, setPutOnMarketplace] = useState(false);
  const [file, setFile] = useState(null);
  const [fileUrl, setFileUrl] = useState(null);
  const [name, setName] = useState("");
  const [descriprion, setDescription] = useState("");
  const [royalties, setRoyalties] = useState("");
  const [price, setPrice] = useState("");
  const theme = useSelector((state) => state.app.theme);

  const handleFileChange = async (e) => {
    const uploadFile = Array.from(e.target.files);
    // exit if file is not of specified image type:
    if (
      !(
        uploadFile[0]?.type === "image/png" ||
        uploadFile[0]?.type === "image/jpeg" ||
        uploadFile[0]?.type === "image/jpg" ||
        uploadFile[0]?.type === "image/gif" ||
        uploadFile[0]?.type === "image/svg+xml" ||
        uploadFile[0]?.type === "video/mp4"
      )
    )
      if (uploadFile[0].size > 100000000) {
        // if file size is larger than 64mb or 64000000 bytes return error
        alert("File must be smaller than 100mb");
        return;
      }
    let url = URL.createObjectURL(uploadFile[0]);
    setFileUrl(url);
    setFile(uploadFile[0]);
  };

  return (
    <CreateNftWrapper>
      <div className='container'>
        <CreateNftWrapperMain>
          <CreateNftLeft>
            <label htmlFor='file'>
              <input type='file' name='file' id='file' onChange={(e) => handleFileChange(e)} />
              {fileUrl ? (
                <img style={{ objectFit: "contain", maxHeight: "100%", maxWidth: "100%" }} id='uploadImage' src={fileUrl} alt='file image' />
              ) : (
                <>
                  <button>{UploadIcon()}Upload</button>
                  File types supported: JPG and PNG. <br /> Max. size: 100MB
                </>
              )}
            </label>
          </CreateNftLeft>
          <CreateNftRight>
            <CreateNftContent>
              <h3>Create NFT</h3>
              <CreateNftSection>
                <h5>
                  Name <span>{name.length}/60</span>
                </h5>
                <label>
                  <input placeholder='Name your NFT' value={name} onChange={(e) => setName(e.target.value)} />
                </label>
              </CreateNftSection>
              <CreateNftSection>
                <h5>
                  Description <span>{descriprion.length}/700</span>
                </h5>
                <label>
                  <textarea
                    onChange={(e) => setDescription(e.target.value)}
                    placeholder='Describe the idea behind your NFT and explain how it stands out from the rest.'
                    rows={5}>
                    {descriprion}
                  </textarea>
                </label>
              </CreateNftSection>
              <CreateNftSection>
                <h5>Categories</h5>
                <CreateDropdown list={categories} active={activeCategories} setActive={setActiveCategories} maxWidth={"200px"} />
              </CreateNftSection>
              <CreateNftSection>
                <h5>Royalties for the Creator</h5>
                <label>
                  <input placeholder='10%' value={royalties} onChange={(e) => setRoyalties(e.target.value)} />
                </label>
                <h6 style={{ marginTop: "15px" }}>
                  <span>Suggested: 0%, 10%, 20%, 30%. The max. is 50%.</span> Collect royalties every time your NFT is sold. The amount is deducted
                  from the final sale price and sent to your address.
                </h6>
              </CreateNftSection>
              <CreateNftSection>
                <h5>Collections</h5>
                <CreateDropdown
                  list={collections}
                  active={activeCollections}
                  setActive={setActiveCollections}
                  defaultValue={"Select Collection"}
                  maxWidth={"100%"}
                />
              </CreateNftSection>
              <CreateNftSection>
                <h5>
                  Put on marketplace
                  <span>
                    <Switch
                      onChange={() => setPutOnMarketplace(!putOnMarketplace)}
                      checked={putOnMarketplace}
                      offColor={theme === "light" ? "#fff" : "#2E2E34"}
                      onColor={theme === "light" ? "#2E2E34" : "#fff"}
                      offHandleColor={theme === "light" ? "#2E2E34" : "#fff"}
                      checkedIcon={false}
                      uncheckedIcon={false}
                      onHandleColor={theme === "light" ? "#fff" : "#2E2E34"}
                      handleDiameter={24}
                      className='switch'
                    />
                  </span>
                </h5>
                <h6>Enter price to allow users purchase your NFT</h6>
              </CreateNftSection>
              {putOnMarketplace && (
                <CreateNftSection>
                  <h5>Price</h5>
                  <label>
                    <input value={price} onChange={(e) => setPrice(e.target.value)} />
                    <span>TON</span>
                  </label>
                  <CreateNftInfo>
                    <div>Service fee</div>
                    <div>
                      <span>0.025 TON</span>2.5%
                    </div>
                  </CreateNftInfo>
                  <CreateNftInfo>
                    <div>You will receive</div>
                    <div>
                      <span>0.975 TON</span> $1,905
                    </div>
                  </CreateNftInfo>
                </CreateNftSection>
              )}
            </CreateNftContent>
            <CreateNftButton>Create New NFT</CreateNftButton>
          </CreateNftRight>
        </CreateNftWrapperMain>
      </div>
    </CreateNftWrapper>
  );
};
